import React from "react";
import moment from "moment";
import { Col, Empty, Row } from "antd";
import OverViewAbout from "../components/OverviewAbout"
import CardLabelProfile from "../../Profile/components/CardLabelProfile";
const AllocatorAboutTab = ({ fundProfileDetails, loading }) => {
  const { profileDetails, getCompanyUsers } = fundProfileDetails;
  // const userStatus = [
  //   {
  //     name: "InActive",
  //     id: 0
  //   },
  //   {
  //     name: "Active",
  //     id: 1
  //   },
  //   {
  //     name: "Rejected",
  //     id: 2
  //   },
  // ]
  return (
    <div
      className="tab-pane fade"
      id="nav-about"
      role="tabpanel"
      aria-labelledby="nav-about-tab"
    >
      <Row>
        <Col span={8}>
          <CardLabelProfile>
            <OverViewAbout
              phoneNumber={profileDetails?.phoneNumber}
              foundedDate={moment(profileDetails?.foundedDate).format(
                "YYYY-MM-DD"
              )}
              headquarterAddress={profileDetails?.address}
              overview={profileDetails?.companyInfo}
              websiteUrl={profileDetails?.websiteUrl}
              investorType={
                profileDetails?.investorTypeName == null
                  ? "Not Found"
                  : profileDetails?.investorTypeName
              }
              loading={loading}
            />
          </CardLabelProfile>
        </Col>
        <Col span={15} offset={1}>
          <Row className="p-3 bg-white" style={{ marginTop: "3rem" }}>
            <Col span={24} className="mt-2 mb-3 ml-2">
              <h5>Allocator Managers</h5>
            </Col>
            {getCompanyUsers.length > 0 ? (
              getCompanyUsers?.map((item) => {
                return (
                  <Col span={7} className="ml-4 mb-3 ">
                    <div className="hf-card2">
                      <div className="hf-card2-banner search-fund-card " style={{ cursor: "pointer" }} >
                          <img className="user-Fund-Card" src={item?.profileUrl ? item?.profileUrl : "/assets/images/bg1.png"} alt="Profile Image" />
                      </div>
                      <div className="hf-card-body p-3" style={{ textAlign: "center" }}>
                        <ul className="extra-info mt-5">
                          <li className="mb-2">
                            <span className="text-dark" style={{ fontSize: "22px", fontWeight: "600", cursor: "pointer" }}>
                              {item?.fullName}
                            </span>
                          </li>
                          <li className="mb-1">
                            {item?.title}
                          </li>
                          <li className="mb-3">
                            {item?.emailAddress}
                          </li>
                          <li className="mb-3">
                            {/* <span class="badge badge-info p-1 mr-2 ">Status: {item?.status ? userStatus[item?.status].name : "N/A"} </span> */}
                            <span class="badge badge-secondary p-1 ">Phone :  {item?.phoneNumber}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                )
              })
            ) : (
              <Row style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Col span={24} >
                  <Empty />
                </Col>
              </Row>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default AllocatorAboutTab;
